import React from 'react';
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import searchIcon from '../../images/search-icon.svg';
import closeIcon from '../../images/close-icon.svg';
import {changeSearchValue, fetchMarkets, setMarketSelected} from '../../actions';
import {MediaQuery} from 'react-responsive';
import device from '../../modules/mediaQuery';
import { withRouter} from 'react-router-dom';
import { setParams } from '../../helpers/Utils';

class MarketSearch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            activeOption: 0,
            filteredOptions: [],
            showOptions: false,
            userInput: ''
        };
    }

    onChange = (e) => {
        const userInput = e.currentTarget.value;

        const filteredOptions = this.props.marketSuggestions.filter(
            (optionName) =>
                optionName.toLowerCase().startsWith(userInput.toLowerCase())
        );

        this.setState({
            activeOption: 0,
            filteredOptions,
            showOptions: true,
            userInput: e.currentTarget.value
        });

    };

    onClick = (e) => {
        this.setState({
            activeOption: 0,
            filteredOptions: [],
            showOptions: false,
            userInput: e.currentTarget.innerText
        });

        this.props.searchClickHandler(false);
        this.filterSearch(e.currentTarget.innerText);

    };

    onKeyDown = (e) => {
        const {activeOption, filteredOptions} = this.state;

        switch (e.keyCode) {
            case 13:
                this.setState({
                    activeOption: 0,
                    showOptions: false,
                    userInput: filteredOptions[activeOption]
                });
                break;
            case 38:
                if (activeOption === 0) {
                    return;
                }

                this.setState({activeOption: activeOption - 1}, () => {
                    this.callMarket()
                });
                break;
            case 40:
                if (activeOption === filteredOptions.length - 1) {
                    return;
                }
                this.setState({activeOption: activeOption + 1}, () => {
                    this.callMarket()
                });
                break;
            default:
                return;
        }
    };

    callMarket() {
        const {activeOption, filteredOptions} = this.state;

        this.setState({userInput: filteredOptions[activeOption]});
    };

    filterSearch(searchval) {
        const {markets, periodList, getData, devicetype, closeimg} = this.props;

        let filteredLists = markets.filter(x => x.market.toLowerCase().includes(searchval.toLowerCase()));

        let selectedGreatregion = (filteredLists[0] ? filteredLists[0].greaterRegion : "Global");
        let latestQuarter = (periodList[periodList.length - 1])

        // This is to prevent url update on the mobile home page search
          
        const windowpath = (window.location.pathname === '/' ? "" : window.location.pathname)
        
        if(windowpath !== this.props.basepath)
        {
         let newUrl = setParams(searchval, 'market')
       //  newUrl = encodeURI(newUrl);
       
         this.props.history.push(`?${newUrl}`);
        }

        getData(latestQuarter, selectedGreatregion, searchval.trim(), devicetype)
    
        this.setState({userInput: ''}) // Clear the search box after search performed
       // this.fetchMarketInfo(searchval)
    };

    fetchMarketInfo(market) {
        const {markets, setMarketSelected} = this.props;
        market = market.trim();
        let region = '';
        let greaterRegion = '';

        markets.find((x) => {
            if (x.market === market) {
                region = x.region;
                greaterRegion = x.greaterRegion
            }
            return null;
        });

        setMarketSelected({greaterRegion, region, market})
    };

    renderMarketsList = (event) => {
        const {userInput} = this.state;

        if (event.keyCode === 13) {
            this.props.searchClickHandler(false);
            if (userInput !== undefined) {
                this.filterSearch(userInput);
            }
        }
    };

    componentDidMount() {
        if(this.props.markets.length <=0)
        {
            this.props.fetchMarkets();
        }
    };

    render() {
        const
            {
                onChange, onClick, onKeyDown,
                state: {activeOption, filteredOptions, showOptions, userInput}
            } = this;

        let marketsearchcss = (this.props.devicetype === 'desktop' ? "market-search-containerdesktop" : "market-search-container col");
        let searchiconcss = (this.props.devicetype === 'desktop' ? "search-icon-desktop" : "search-icon");
        let searchtextboxcss = (this.props.devicetype === 'desktop' ? "search-text-box-desktop" : "search-text-box");
        let marketsuggestioncss = (this.props.devicetype === 'desktop' ? "market-suggestions-desktop" : "market-suggestions");

        let optionList;
        if (showOptions && userInput.length > 1) {
            if (filteredOptions.length) {
                optionList = (
                    <ul className={marketsuggestioncss}>
                        {filteredOptions.map((optionName, index) => {
                            let className;
                            if (index === activeOption) {
                                className = 'option-active';
                            }
                            return (
                                <li className={className} key={optionName} onClick={onClick}>
                                    {optionName}
                                </li>
                            );
                        })}
                    </ul>
                );
            } else {
                optionList = (
                    <ul className={marketsuggestioncss}>
                        <em className="no-options">No markets found</em>
                    </ul>
                );
            }
        }
        return (
            <div className={marketsearchcss}>
                <div className="search-input-container">
                    {/* <MediaQuery query={device.max.tablet}><img className={searchiconcss} alt="search-icon"
                                                               src={searchIcon}/></MediaQuery> */}

                    <input className={searchtextboxcss} type="text"
                           placeholder="Search markets"
                           autoFocus
                           onKeyUp={this.renderMarketsList}
                           onChange={onChange}
                           onKeyDown={onKeyDown}
                           value={userInput || ''} maxLength="50"
                    />
                    
                    <img className={searchiconcss} alt="search-icon" src={'#{rentrackerappimages}#' + '/search-icon.svg'}/>

                </div>
                {this.props.devicetype !== 'desktop' && this.props.closeimg!=='false' ?
                    <img className="close-icon" alt="close-icon" src={'#{rentrackerappimages}#' + '/close-icon.svg'}
                         onClick={() => this.props.searchClickHandler(false)}/> :
                    ''
                }
                {optionList}
            </div>
        )
    }
}

MarketSearch.propTypes = {
    searchClickHandler: PropTypes.func.isRequired,
    marketSuggestions: PropTypes.instanceOf(Array).isRequired
};

const mapStateToProps = (state) => {
    return {
        markets: state.markets,
        periodList: state.periodList,
        basepath : state.basepath
    };
};


const mapDispatchToProps = (dispatch) => {
    return {
        getData: (latestQuarter, selectedGreatregion, searchval, searchdevice) => {
            dispatch(changeSearchValue(latestQuarter, selectedGreatregion, searchval, searchdevice))
        },
        fetchMarkets: () => {
            dispatch(fetchMarkets())
        },
        setMarketSelected: (selection) => {
            dispatch(setMarketSelected(selection))
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MarketSearch));